export { default as FieldGuideLanding } from "./FieldGuideLanding";
export { default as TopographicLanding } from "./TopographicLanding";
export { default as LodgeBulletinLanding } from "./LodgeBulletinLanding";
export { default as NatureMinimalLanding } from "./NatureMinimalLanding";
export { default as SummitLanding } from "./SummitLanding";

export const LAYOUT_OPTIONS = [
  {
    id: "field-guide",
    name: "Field Guide",
    description: "Editorial magazine aesthetic with serif typography and asymmetric layouts",
    component: "FieldGuideLanding",
  },
  {
    id: "topographic",
    name: "Topographic",
    description: "Cartographic technical aesthetic with grid systems and monospace typography",
    component: "TopographicLanding",
  },
  {
    id: "lodge-bulletin",
    name: "Lodge Bulletin",
    description: "Warm rustic aesthetic with pinned cards and handwritten accents",
    component: "LodgeBulletinLanding",
  },
  {
    id: "nature-minimal",
    name: "Nature Minimal",
    description: "Scandinavian clean aesthetic with generous whitespace and organic shapes",
    component: "NatureMinimalLanding",
  },
  {
    id: "summit",
    name: "Summit",
    description: "Photo-first outdoor magazine layout with hero images and carousels",
    component: "SummitLanding",
  },
] as const;

export type LayoutId = (typeof LAYOUT_OPTIONS)[number]["id"];
